// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9cd9bf47","977":"6c449fc8"}[chunkId] + ".chunk.js";
};